/* DHC v911 — Shop by Theme carousel */
(function(){
'use strict';
function bind(root){
  if(!root||root.dataset.dhcThemeCarouselReady==='1')return;
  root.dataset.dhcThemeCarouselReady='1';
  var track=root.querySelector('[data-dhc-theme-track]');
  var prev=root.querySelector('[data-dhc-theme-prev]');
  var next=root.querySelector('[data-dhc-theme-next]');
  if(!track)return;

  function step(){
    var first=track.querySelector('a');
    if(!first)return Math.max(220,track.clientWidth*.7);
    var gap=12;
    return Math.max(first.getBoundingClientRect().width+gap, track.clientWidth*.55);
  }
  function update(){
    var max=Math.max(0,track.scrollWidth-track.clientWidth-2);
    if(prev)prev.disabled=track.scrollLeft<=2;
    if(next)next.disabled=track.scrollLeft>=max;
  }
  if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
  if(next)next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
  track.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',update,{passive:true});
  update();
}
function boot(){document.querySelectorAll('[data-dhc-theme-carousel]').forEach(bind);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
document.addEventListener('shopify:section:load',boot);
})();